// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2s17o","info":"Note_info__3d5QM","note":"Note_note__wg8wt","actions":"Note_actions__3HwPw"};